import { NotificationSeverity } from '../services/notifier';
import { Notification } from './notification';

export class NotificationError extends Notification {
  protected severity: NotificationSeverity = 'error';
}
